import React, { Fragment, useContext, useEffect, useState } from "react";
import { getApi, postApi } from "../../services/api/globalApi";
import { Field, Form, Formik } from "formik";
import { motion } from "framer-motion"
import { toast } from "react-toastify";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { digitsThree } from "../../utils/price";
import { context } from "../../context/context";


const ProfitLoansFormula = () => {

    const { showLogutModal} = useContext(context)

    const [data, setData] = useState(null)

    const getCurrentLoan = async () => {
        try {
            const data = await getApi({ path: "ProfitLoansFormula/new" })
            console.log(data.data.data)
            setData(data.data.data)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getCurrentLoan()
    }, [])

    const formHandler = async (values, { resetForm }) => {
        try {
            const body = {
                loan: {
                    perMounth: values.perMounth || data?.loan.perMounth,
                    totalProfit: values.totalProfit || data?.loan.totalProfit
                }
            }

            const response = await postApi({
                path: 'admin/profitLoansFormula/createOrUpdate',
                body: body
            });
            toast.success("تغییرات با موفقیت ثبت شد.", {
                position: "top-right",
                closeOnClick: true
            });
            resetForm()
            getCurrentLoan()

        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.errors.message, {
                position: "top-right",
                closeOnClick: true
            });
            error?.response.status == 401 && showLogutModal();
        }
    }

    return (
        <Fragment>
            <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                    duration: 0.5,
                    // ease: [0, 0.71, 0.2, 1.01]
                }} className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6">

                <h6 className="mb-6 mt-2 text-gray-800 dark:text-white flex gap-x-2 items-center">
                    <span className="flex items-center justify-center text-lg text-white">
                        <svg fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            className="h-6 w-6">
                            <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
                        </svg>
                    </span>
                    سود وام اقساط کالا
                </h6>

                <div className="dark:text-white w-11/12 mx-auto mt-4">
                    <div className="flex w-full items-center justify-center flex-wrap pz-10 gap-4">

                       <div class="bg-gradient-to-b from-green-500 dark:from-green-700 to-green-200 dark:to-green-400 border-b-4 border-green-600 dar:border-green-900 rounded-lg shadow-xl p-5">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pl-4">
                                <div class="rounded-full p-5 bg-green-600 dark:bg-green-900">
                                        <FaMoneyBillTrendUp size={30} />
                                    </div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold">درصد ماهانه وام اقساط کالا</h5>
                                    <h3 class="font-bold text-3xl mt-2">{data ? digitsThree(data?.loan.perMounth) : null}</h3>
                                </div>
                            </div>
                        </div>

                       <div class="bg-gradient-to-b from-green-500 dark:from-green-700 to-green-200 dark:to-green-400 border-b-4 border-green-600 dar:border-green-900 rounded-lg shadow-xl p-5">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pl-4">
                                <div class="rounded-full p-5 bg-green-600 dark:bg-green-900">
                                        <FaMoneyBillTrendUp size={30} />
                                    </div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold">درصد نهایی مبلغ وام</h5>
                                    <h3 class="font-bold text-3xl mt-2">{data ? digitsThree(data?.loan.totalProfit) : null}</h3>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex gap-x-8 mt-6">
                        <div className="w-full flex gap-x-6">
                            <Formik
                                initialValues={{
                                    perMounth: '',
                                    totalProfit: '',
                                }}
                                // validationSchema={validate}
                                onSubmit={formHandler}
                            >

                                {(formik) => (
                                    <Form className="w-full">
                                        <h4 className="mb-6">درصد جدید را وارد کنید.</h4>
                                        <div className="grid gap-6 mb-6 md:grid-cols-2">
                                            <div>
                                                <label for="perMounth" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">درصد ماهانه وام اقساط کالا</label>
                                                <Field autocomplete="off" type="text" name="perMounth" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                    placeholder="درصد ماهانه وام اقساط کالا" />
                                                {formik.errors.perMounth && formik.touched.perMounth ? (
                                                    <p className="text-sm my-4 text-red-500">{formik.errors.perMounth}</p>
                                                ) : null}
                                            </div>
                                            <div>
                                                <label for="totalProfit" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">درصد نهایی مبلغ وام</label>
                                                <Field autocomplete="off" type="text" name="totalProfit" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                    placeholder="درصد نهایی مبلغ وام" />
                                                {formik.errors.totalProfit && formik.touched.totalProfit ? (
                                                    <p className="text-sm my-4 text-red-500">{formik.errors.totalProfit}</p>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="w-full flex justify-end">
                                            <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-10 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                                تغییر
                                            </button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </motion.div>

        </Fragment>
    )
}

export default ProfitLoansFormula